var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.hide)?_c('button',_vm._g(_vm._b({key:_vm.isChecked ? 1 : 0,class:[
    _vm.status,
    {
      'has-title': _vm.hasTitle,
      checked: _vm.isChecked,
    },
  ],attrs:{"type":"button"},on:{"click":_vm.btnCliked}},'button',_vm.$attrs,false),_vm.$listeners),[(_vm.iconSrc)?_c('img',{staticClass:"img-icons",attrs:{"src":_vm.iconSrc,"alt":"VACAN"}}):(_vm.iconName)?_c('img',{attrs:{"src":`${_vm.iconUri}/${_vm.iconName}.svg`,"width":_vm.iconName === 'tune' ? 26 : 20,"height":_vm.iconName === 'tune' ? 26 : 20,"alt":_vm.iconName}}):_vm._e(),(_vm.title)?_c('span',{staticClass:"title",class:{ 'hide-title': !_vm.hasTitle }},[_vm._v(" "+_vm._s(_vm.shrinkTitle(_vm.name, _vm.convertedTitle, _vm.iconSrc))+" ")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }